import React from "react";
import { NavLink } from "react-router-dom";
import "./commonComponent.css";

export const Breadcrumb = ({ paths }) => {
  return (
    <div className="breadcrumb">
      {paths.map((path, index) => (
        <div className="breadcrumb-item" key={index}>
          <div className="breadcrumb-item-main" key={index}>
            {index === paths.length - 1 ? (
              path.label
            ) : (
              <NavLink
                className={"breadcrumb_nav_link"}
                to={path.url}
                activeClassName="active"
              >
                {path.label}
              </NavLink>
            )}
          </div>
          <div className="breadcrumb-item-icon">
            <i className="fa-solid fa-angles-right"></i>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Breadcrumb;
